import { Button } from "@/components/ui/button";
import { horaNaFazenda } from "@shared/data-fazenda";
import { RefreshCw } from "lucide-react";

// "Atualizado às 14:05" + botão Atualizar (44 px). A hora é a da FAZENDA — o
// operador alterna entre o WhatsApp e o app e precisa saber se o que vê é de agora.
export function BarraAtualizacao({ dataUpdatedAt, buscando, onAtualizar }: {
  dataUpdatedAt: number;
  buscando: boolean;
  onAtualizar: () => void;
}) {
  return (
    <div className="flex items-center justify-between gap-2 text-sm text-muted-foreground" data-testid="barra-atualizacao">
      <span>{dataUpdatedAt > 0 ? `Atualizado às ${horaNaFazenda(dataUpdatedAt)}` : "Carregando…"}</span>
      <Button
        type="button" variant="ghost" className="min-h-11 min-w-11 px-0"
        onClick={onAtualizar} disabled={buscando} aria-label="Atualizar" data-testid="btn-atualizar"
      >
        <RefreshCw className={buscando ? "h-4 w-4 animate-spin" : "h-4 w-4"} />
      </Button>
    </div>
  );
}
